import script from "./DisProxyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./DisProxyContent.vue?vue&type=script&setup=true&lang=js"

import "./DisProxyContent.vue?vue&type=style&index=0&id=6557af82&scoped=true&lang=css"

import exportComponent from "../../../../../../../var/local/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6557af82"]])

export default __exports__